<template>
  <input
    :id="inId"
    class="input-style"
    :type="inType"
    :placeholder="inText"
  >
</template>

<script>
export default {
  props: {
    inText: {
      type: String,
      default: ''
    },
    inType: {
      type: String,
      default: ''
    },
    inId: {
      type: String,
      default: ''
    }
  }
}
</script>
